import { render, staticRenderFns } from "./bookingCancelled.vue?vue&type=template&id=7031ba37&scoped=true"
import script from "./bookingCancelled.vue?vue&type=script&lang=js"
export * from "./bookingCancelled.vue?vue&type=script&lang=js"
import style0 from "./bookingCancelled.vue?vue&type=style&index=0&id=7031ba37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031ba37",
  null
  
)

export default component.exports